import * as React from 'react'
import { Icon } from '../../atoms/icon'
import { Size, Color } from '../../../constants/app.constant'

interface Props {
  evaluation: number
}

export default (props: Props) => (
  <>
    {(() => {
      if (props.evaluation === 0) {
        return (
          <Icon.Status0
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_0}
          />
        )
      } else if (props.evaluation === 1) {
        return (
          <Icon.Status1
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_1}
          />
        )
      } else if (props.evaluation === 2) {
        return (
          <Icon.Status2
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_2}
          />
        )
      } else if (props.evaluation === 3) {
        return (
          <Icon.Status3
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_3}
          />
        )
      } else {
        return (
          <Icon.Status4
            size={`${Size.LARGE}px`}
            color={Color.STATUS_COLOR.STATUS_4}
          />
        )
      }
    })()}
  </>
)



// WEBPACK FOOTER //
// ./src/components/molecules/status-icon/status-icon.tsx